import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import Swal from 'sweetalert2'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useUsersList() {
  const { t } = useI18nUtils()
  // Use toast
  const toast = useToast()
  const yes = t('Yes, delete it!')
  const areYouSure = t('Are you sure?')
  const detail = t("You won't be able to revert this!")
  const cancel = t('Cancel')
  const refUserListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'title', class: "col-12", sortable: true },
    { key: 'actions', class: "col-12 text-center" },
  ]
  const perPage = ref(10)
  const totalUsers = ref(0)
  const totalUsersByDepartment = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refUserListTable.value ? refUserListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalUsers.value,
    }
  })

  const refetchData = () => {
    fetchCertificates();
    // fetchInstructersByDepartment(JSON.parse(localStorage.getItem('userData'))?.additionalInfo?.DEPARTMENTID ?? 0);
  }

  // watch([ roleFilter, planFilter, statusFilter], () => {
  //   refetchData()
  // })
  const items = ref(null)
  const itemsByDepartment = ref(null)
  const byDepartment = ref(true)
  const fetchCertificates = (ctx, callback) => {
    store
      .dispatch('apps-certificate/fetchCertificates', {

      })
      .then(response => {
        const { data } = response.data
        //console.log("Fetch Instructors");
        items.value = data
        // callback(data)
        totalUsers.value = items.value.length
      })
      .catch((err) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }
  const fetchInstructersByDepartment = (id) => {
    store
      .dispatch('apps-certificate/fetchCertificatesByDepartment', { id })
      .then(response => {
        const { data } = response.data
        itemsByDepartment.value = data
        totalUsersByDepartment.value = itemsByDepartment.value.length
        if (itemsByDepartment.value.length > 0) {
          byDepartment.value = true
          
        } else {
          byDepartment.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: "Please check Admin User's department",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      })
      .catch((err) => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Please check Admin User's department",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }
  const deleteCertificate = (id) => {
   
    Swal.fire({
      title: areYouSure,
      text: detail,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: yes,
      cancelButtonText:  cancel,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
      },
      buttonsStyling: false, 
    }).then(result =>{
      console.log(id)
      if (result.isConfirmed) {
        store
      .dispatch('apps-certificate/deleteCertificate', {id})
      .then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Instructer Deleted',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        refetchData()
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error deleting instructer',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      }
    })
    
  }
  // fetchInstructersByDepartment(JSON.parse(localStorage.getItem('userData'))?.additionalInfo?.DEPARTMENTID ?? 0)
  fetchCertificates()
  

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 0) return 'warning'
    if (status === 1) return 'success'
    if (status === 2) return 'secondary'
    return 'primary'
  }
  const resolveUserStatusVariantText = status => {
    if (status === 0) return 'deleted'
    if (status === 1) return 'active'
    if (status === 2) return 'disabled'
    return 'primary'
  }

  return {
    fetchCertificates,
    tableColumns,
    perPage,
    currentPage,
    totalUsers,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refUserListTable,
    items,
    itemsByDepartment,
    byDepartment,
    totalUsersByDepartment,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    resolveUserStatusVariantText,
    refetchData,
    deleteCertificate,


    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
